const isInternal = () => {
  try {
    if (localStorage.getItem("ruta360_interno") === "1") return true;
  } catch {
    return true;
  }
  return typeof window !== "undefined" && window.location.pathname.startsWith("/admin");
};

export const fbqTrack = (event, data, options) => {
  if (isInternal()) return;
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    if (options) window.fbq("track", event, data || {}, options);
    else window.fbq("track", event, data || {});
  }
};

export const fbqPurchaseOnce = (orderNumber, data) => {
  if (!orderNumber) return;
  const key = `ruta360_purchase_${orderNumber}`;
  try {
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, "1");
  } catch {
    return;
  }
  fbqTrack("Purchase", data, { eventID: String(orderNumber) });
};
